import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useStyles = makeThemedStyles("mytasks", (theme) => ({
  pageContainer: {
    background: "#edf3f4",
    height: "100vh",
    minWidth: "unset",
  },
}));

const MyTasksContainer = (props: React.PropsWithChildren<{}>) => {
  const styles = useStyles();
  return <div className={styles.pageContainer}>{props.children}</div>;
};

export default MyTasksContainer;
